// Parlament: Anhörung im Ausschuss, Abweichler in den Fraktionen, Deals mit den Ländern im Bundesrat.
import { TPL } from '../content/issues';
import { ISS } from '../content/states';
import { LOBBIES } from '../content/lobbies';
import { OUTLETS } from '../content/parties';
import { on } from '../content/settings';
import { vrOf } from './court';
import { lobbyDelta } from './lobbies';
import { press } from './media';
import { S, log } from './state';
import { clamp, de } from './util';
import { hearingV2 } from './v2';

export interface Hearing { who: string; txt: string; tone: number }

/** Sachverständige, Verbände und Länder bewerten den Entwurf in der Ausschussanhörung. */
export function hearing(L: any, brShare: number | null): Hearing[] {
  const f = L.fx || {}, out: Hearing[] = [];
  const T = L.iss ? TPL(L.iss, L.tpl || 0) : null;
  if ((f.b || 0) <= -5) out.push({ who: 'Bundesrechnungshof', txt: `Mit ${de(-f.b, 1)} Mrd € pro Jahr sehr teuer, die Gegenfinanzierung ist unklar.`, tone: -1 });
  else if ((f.b || 0) > 1) out.push({ who: 'Bundesrechnungshof', txt: 'Entlastet den Haushalt. Die Mehreinnahmen sind plausibel gerechnet.', tone: 1 });
  if ((f.gr || 0) >= .05) out.push({ who: 'Wirtschaftsforschungsinstitute', txt: 'Stärkt das Wachstum spürbar.', tone: 1 });
  else if ((f.gr || 0) <= -.04) out.push({ who: 'Wirtschaftsforschungsinstitute', txt: 'Belastet die Konjunktur.', tone: -1 });
  const vr = T ? vrOf(T, L.p || {}) : 0;
  if (vr >= .15) out.push({ who: 'Verfassungsrechtler', txt: 'Erhebliche verfassungsrechtliche Bedenken. Eine Klage in Karlsruhe ist wahrscheinlich.', tone: -1 });
  else if (vr >= .05) out.push({ who: 'Verfassungsrechtler', txt: 'Einzelne Regelungen sind verfassungsrechtlich angreifbar.', tone: -.5 });
  if (on('lobby')) {
    const d = lobbyDelta(f);
    const ks = Object.keys(LOBBIES).filter((k) => Math.abs(d[k]) >= 3).sort((a, b) => Math.abs(d[b]) - Math.abs(d[a])).slice(0, 2);
    for (const k of ks) out.push({ who: LOBBIES[k].n, txt: d[k] > 0 ? 'Begrüßen den Entwurf ausdrücklich.' : 'Lehnen den Entwurf scharf ab und kündigen Widerstand an.', tone: d[k] > 0 ? 1 : -1 });
  }
  const side = f.side || {}, worst = Object.keys(side).filter((k) => side[k] >= 2).sort((a, b) => side[b] - side[a])[0];
  if (worst) out.push({ who: 'Sachverständige', txt: `Warnen vor Nebenwirkungen: Das Gesetz verschärft ${ISS[worst]?.n ?? 'ein anderes Problem'}.`, tone: -.5 });
  if (brShare != null && L.br) out.push(brShare > .5 ? { who: 'Länder', txt: 'Signalisieren Zustimmung im Bundesrat.', tone: .5 } : { who: 'Länder', txt: 'Kündigen Widerstand im Bundesrat an und fordern mehr Geld vom Bund.', tone: -1 });
  out.push(...hearingV2(L));
  if (!out.length) out.push({ who: 'Sachverständige', txt: 'Halten den Entwurf für solide, ohne große Einwände.', tone: .3 });
  return out;
}

/** Anhörung durchführen, wenn der Entwurf in den Bundestag kommt. Das Echo beeinflusst die Presse. */
export function runHearing(L: any, brShare: number | null) {
  L.hear = hearing(L, brShare);
  const sum = L.hear.reduce((s: number, h: Hearing) => s + h.tone, 0);
  if (sum <= -1.5) { press(OUTLETS[1].n, `Anhörung zu „${L.t}“: Experten zerpflücken den Entwurf`, -.5); log(`Anhörung im Ausschuss: viel Kritik an „${L.t}“. Ihr könnt den Entwurf noch zurückziehen und nachbessern.`, 'bad'); }
  else if (sum >= 1.5) { press(OUTLETS[0].n, `Anhörung zu „${L.t}“: Breite Zustimmung der Fachleute`, .4); log(`Anhörung im Ausschuss: viel Zustimmung für „${L.t}“.`, 'good'); }
  else log(`Anhörung im Ausschuss zu „${L.t}“: gemischtes Echo.`);
}

/** Abweichler in einer Fraktion: Je weniger das Gesetz zur Partei passt, desto mehr stimmen dagegen. */
export function defectors(seats: number, s: number, limit: number): number {
  if (s >= limit) return 0;
  return Math.round(seats * clamp((limit - s) * .55, 0, .22));
}

export const DEAL_COST = 1.5;
/** Den Ländern Finanzhilfe anbieten, damit der Vermittlungsausschuss einen Kompromiss findet. */
export function brDeal(L: any) {
  if (!L || L.stage !== 'vm' || L.deal) return;
  L.deal = true; S.lawB -= DEAL_COST;
  log(`Für „${L.t}“ bietet der Bund den Ländern ${de(DEAL_COST, 1)} Mrd € pro Jahr an.`);
  press(OUTLETS[1].n, `Kuhhandel im Bundesrat? Bund kauft sich Zustimmung zu „${L.t}“`, -.2);
}
